"use client";
import parse from "html-react-parser";

const HtmlParser: React.FC<{ html: string }> = ({ html }) => {
  if (!html ) return <></>
  return parse(`${html}`);
};
export default HtmlParser;
